module.exports = __webpack_public_path__ + "./docs/img/code-example-3.90fa7090ab1bb111b60519a8ccde13bf.svg";